module.exports = __webpack_public_path__ + "static/media/defaultUser.9d5c141d.svg";